/**
 * FeedbackTypeService
 * Service for FeedbackType entity operations
 * Route: api/feedbacktype
 */
import { CrudService } from '../base/CrudService';
/**
 * FeedbackTypeService
 * Handles feedback type CRUD operations
 */
export class FeedbackTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FeedbackTypeService.DEFAULT_SERVICE_PATH,
            basePath: FeedbackTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
FeedbackTypeService.DEFAULT_SERVICE_PATH = 'feedbacks';
FeedbackTypeService.BASE_PATH = 'api/feedbacktype';
//# sourceMappingURL=FeedbackTypeService.js.map